export const MODAL_BANK_SWAP_SHOW = "MODAL_BANK_SWAP_SHOW";
export const MODAL_BANK_SWAP_HIDE = "MODAL_BANK_SWAP_HIDE";

const initialState = {
  showBankSwap: false
};

export default function modalReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MODAL_BANK_SWAP_SHOW:
      return payload;

    case MODAL_BANK_SWAP_HIDE:
      return payload;

    default:
      return state;
  }
}

export function showBankSwapModal() {
  return {
    type: MODAL_BANK_SWAP_SHOW,
    payload: {
      showBankSwap: true
    }
  };
}

export function hideBankSwapModal() {
  return {
    type: MODAL_BANK_SWAP_HIDE,
    payload: {
      showBankSwap: false
    }
  };
}
